import List from './List.jsx';
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';

export default {
  list: List,
  icon: DashboardOutlinedIcon
};